import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 24,
    width: "100%",
    maxWidth: 400,
    margin: theme.spacing(2),
    padding: theme.spacing(4, 3, 3),
    boxSizing: "border-box",
    fontFamily: "'Lato', 'Segoe UI', sans-serif",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: theme.spacing(1.5),
  },
  iconCircle: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      fontSize: 38,
    },
  },
  success: {
    backgroundColor: "#E9FBF0",
    color: "#0B7A3B",
  },
  error: {
    backgroundColor: "#FEECEC",
    color: "#B42318",
  },
  title: {
    fontFamily: "'Nunito Sans', 'Avenir Next', 'Segoe UI', sans-serif",
    fontSize: "1.4rem",
    fontWeight: 800,
    lineHeight: 1.32,
    margin: 0,
    "&.MuiTypography-root": {
      fontWeight: 700,
    },
  },
  successTitle: {
    color: "#0B7A3B",
  },
  errorTitle: {
    color: "#B42318",
  },
  description: {
    fontSize: "0.95rem",
    color: "#5B5D66",
    lineHeight: 1.4,
    margin: 0,
  },
  actions: {
    marginTop: theme.spacing(2.5),
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
}));

export default useStyles;
